<footer class="site-footer">
  <div class="footer-container">
    <div class="footer-brand">
      <h2>{{ footer.brandName }}</h2>
      <p>{{ footer.description }}</p>
    </div>

    <div class="footer-links">
      <h3>{{ footer.quickLinksTitle }}</h3>
      <ul>
        @for(link of quickLinks; track $index) {
          <li>
            <a [href]="link.url">{{ link.title }}</a>
          </li>
        }
      </ul>
    </div>

    <div class="footer-contact">
      <h3>{{ footer.contactTitle }}</h3>
      <ul>
        @for(item of contactItems; track $index) {
        <li>
          <i class="footer-icon {{ item.icon }}"></i>
          @if(item.value) {
            <a [href]="item.value" target="_blank" rel="noreferrer">{{ item.label }}</a>
          }@else {
            <span>{{ item.label }}</span>
          }
        </li>
        }
      </ul>
    </div>
  </div>

  <div class="footer-bottom">
    <p>{{ footer.copyright }}</p>
  </div>
</footer>
